// Freeze to make the object immutable
export const filter_constants = Object.freeze({
    category: [
        'Movies',
        'Sports',
        'Kids',
        'Learning',
        'Music',
        'News',
        'Lifestyle',
        'Variety Entertainment',
        'Special interest',
        'Radio',
    ],
    language: [
        'International',
        'Malay',
        'Chinese',
        'Indian',
        'Korean & Japanese',
        'Multiple Languages',
    ],
    resolution: ['SD', 'HD'],
})

export const day_constants = Object.freeze({
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
})
